import {typeUtil} from "@repo/lib-common"
import {AdUnit} from "./adUnit";

//#region gpt mix types
export type GptSlot = googletag.Slot;
export type TargetingMap = typeUtil.ObjectIndexer<string>;
export type AdUnitMap = typeUtil.ObjectIndexer<AdUnit>
export const NamedSize_Val1 = "fluid";
export const NamedSize_Val2 = ["fluid"];
export type NamedSize = "fluid" | ["fluid"];
export type SingleSize = [number, number];
export type SingleSizeMix = SingleSize | NamedSize;
export type MultiSize = SingleSizeMix[];

export type SingleSizeArray = SingleSize[];
export type GeneralSize = SingleSizeArray | SingleSize | NamedSize | SingleSizeMix | MultiSize;

export type GptSlotRenderEndedEventData = googletag.events.SlotRenderEndedEvent;
export type GptSlotRequestedEventData = googletag.events.SlotRequestedEvent;
export type GptSlotOnloadEventData = googletag.events.SlotOnloadEvent;
export type GptImpressionViewableEventData = googletag.events.ImpressionViewableEvent;
export type GptSlotResponseReceivedEventData = googletag.events.SlotResponseReceived;
export type GptSlotVisibilityChangedEventData = googletag.events.SlotVisibilityChangedEvent;


export class GptSlotRenderEndedEvent {
    constructor(eventData?: GptSlotRenderEndedEventData) {
        this.eventData = eventData;
    }

    createdAt: Date = new Date();
    eventData?: GptSlotRenderEndedEventData
}

export class GptSlotRequestedEvent {
    constructor(eventData?: GptSlotRequestedEventData) {
        this.eventData = eventData;
    }
    createdAt: Date = new Date();
    eventData?: GptSlotRequestedEventData
}

export class GptSlotOnloadEvent {
    constructor(eventData?: GptSlotOnloadEventData) {
        this.eventData = eventData;
    }
    createdAt: Date = new Date();
    eventData?: GptSlotOnloadEventData
}

export class GptImpressionViewableEvent {
    constructor(eventData?: GptImpressionViewableEventData) {
        this.eventData = eventData;
    }
    createdAt: Date = new Date();
    eventData?: GptImpressionViewableEventData
}

export class GptSlotResponseReceivedEvent {
    constructor(eventData?: GptSlotResponseReceivedEventData) {
        this.eventData = eventData;
    }
    createdAt: Date = new Date();
    eventData?: GptSlotResponseReceivedEventData
}

export class GptSlotVisibilityChangedEvent {
    constructor(eventData?: GptSlotVisibilityChangedEventData) {
        this.eventData = eventData;
    }
    createdAt: Date = new Date();
    eventData?: GptSlotVisibilityChangedEventData
}

//#endregion

